import { useLocation, Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Layout from "@/components/feature/Layout";

export default function NotFound() {
  const location = useLocation();
  const { t } = useTranslation();
  
  return (
    <Layout>
      <div className="relative flex flex-col items-center justify-center min-h-[70vh] text-center px-4">
        <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0 font-heading">
          404
        </h1>
        <div className="relative z-10">
          <h1 className="text-xl md:text-2xl font-semibold mt-6 font-heading">{t('notFound.title')}</h1>
          <p className="mt-2 text-base text-foreground-400 font-mono">{location.pathname}</p>
          <p className="mt-4 text-lg md:text-xl text-foreground-500">{t('notFound.description')}</p>
          <Link to="/" className="inline-flex items-center gap-2 mt-8 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg transition-colors">
            {t('notFound.backHome')}
            <i className="ri-home-line"></i>
          </Link>
        </div>
      </div>
    </Layout>
  );
}